import React, { useState, useEffect } from 'react';
import Tools from '../../Tools';
import Popover from '../../ui/Popover';
import IconView from '../../icons/IconView';

const DocsTanner = (props) => {

    const [selectedAllDocs, setSelectedAllDocs] = useState(true);
    const [loading, setLoading] = useState({ client: false, campaign: false, tasks: false, documents: false, patent: false });
    const [error, setError] = useState(false);
    const [documentId, setDocumentId] = useState(null);
    const [currentRow, setCurrentRow] = useState(-1);

    const toggleAllDebts = () => {
        setSelectedAllDocs(!selectedAllDocs); //variable to toggle
        if (selectedAllDocs) {
            props.documents.forEach(d => { d.selected = false; });
            props.setDebtFn(0);
        } else {
            props.documents.forEach(d => { d.selected = true; });
            props.setDebtFn(props.documents.reduce((a, doc) => { return a + Number(doc.saldo_pend - ((doc.dscto / 100) * doc.saldo_pend)); }, 0));
        }
    }

    const selectDebt = (event, doc) => {
        if (!event.target.checked) {
            doc.selected = false;
            props.setDebtFn(props.debt - Number(event.target.value));
        } else {
            doc.selected = true;
            props.setDebtFn(props.debt + Number(event.target.value));
        }
    }

    useEffect(() => {
        //const totalDebt = props.documents.reduce((a, doc) => { return a + Number(doc.saldo_pend - ((doc.dscto / 100) * doc.saldo_pend)); }, 0);
        const totalDebt = props.documents.reduce((a, doc) => { return a + Number(doc.monto_adeudado); }, 0);
        props.setDebtFn(totalDebt);
    }, [props.documents]);

    return (
        <table className="fullWidth">
            <thead>
                <tr>
                    <th><input type="checkbox" onChange={toggleAllDebts} defaultChecked={true} /> &nbsp; Canal venta</th>
                    <th className='center'>Id Crédito</th>
                    <th className='center'>S. Insoluto</th>
                    <th className='center'>Cuotas morosas</th>
                    <th className='center'>Próximo Vcto.</th>
                    <th className='right'>Días mora</th>
                    <th className='right'>Monto Cuota</th>
                    <th className='center'>Int. mora total</th>
                    <th className='right'>GC Total</th>
                    <th className='right'>Deuda</th>
                    <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                {props.documents.map((doc, index) => {
                    return (
                        <tr key={index}>
                            <td>
                                <label className="forCheckbox">
                                    <input type="checkbox" name={'ckeck' + index} value={doc.saldo_pend - ((doc.dscto / 100) * doc.saldo_pend)} onChange={(e) => selectDebt(e, doc)} checked={doc.selected} defaultChecked={true} />
                                    {doc.canal_venta}
                                </label>
                            </td>
                            <td className="center">{doc.num_documento}</td>
                            <td className="right">{Tools.fmtClAmmount(doc.saldo_insoluto)}</td>
                            <td className="right">{doc.cuotas_mora}</td>
                            <td className="center">{doc.fecha_prox_vcto}</td>
                            <td className="center">{doc.dias_mora}</td>
                            <td className="right">{Tools.fmtClAmmount(doc.cuota_total)}</td>
                            <td className="right">{Tools.fmtClAmmount(doc.int_mora_total)}</td>
                            <td className="right">{Tools.fmtClAmmount(doc.gc_total)}</td>
                            <td className="right">{Tools.fmtClAmmount(doc.monto_adeudado)}</td>
                            <td className="rel">
                                <a style={{ "anchorName": `--pop-car-info${index}` }} tooltip="Info vehículo" className="popupAnchor" onClick={() => setCurrentRow(index===currentRow?-1:index)}><IconView size="25" color="#949494" /></a>
                                <Popover className="anchored" anchorName={`--pop-car-info${index}`} show={index === currentRow} width="340px">
                                    <dl>
                                        <dt>Marca</dt><dd>{doc.vehiculo_1_marca}</dd>
                                        <dt>Modelo</dt><dd>{doc.vehiculo_1_modelo}</dd>
                                        <dt>Año</dt><dd>{doc.vehiculo_1_anio}</dd>
                                    </dl>
                                </Popover>
                            </td>
                        </tr>

                    );
                })}
            </tbody>
        </table>
    );

}

export default DocsTanner;